export default {
  LOAD_TRANSLATIONS: '@YOLA_EDITOR/I18N/LOAD_TRANSLATIONS',
  SET_LOCALE: '@YOLA_EDITOR/I18N/SET_LOCALE',
};
